module.exports = __webpack_public_path__ + "img/MX.21b37d3b.svg";